import {
  get_axios_instance,
  api_variables,
  errorHandler,
  errorLogSheet
} from "@/apis/variables.js";

var axios_instance1 = get_axios_instance(api_variables.SERVICE_UPLOAD_LOP_RLOP);
var axios_instance2 = get_axios_instance(api_variables.SERVICE_LOP_RLOP);
var axios_filter_instance = get_axios_instance(
  api_variables.SERVICE_LOPRLOP_FILTER
);
var axios_instance_upload_template = get_axios_instance(
  api_variables.SERVICE_LOP_RLOP_UPLOAD_TEMPLATE
);
var axios_instance_upload_onsite_template = get_axios_instance(
  api_variables.SERVICE_UPLOAD_TEMPLATE_ONSITE
);
var axios_instance_upload_taxoutsidepayroll_template = get_axios_instance(
  api_variables.SERVICE_UPLOAD_TEMPLATE_TAXOUTSIDEPAYROLL
);
var axios_instance_upload_installment_template = get_axios_instance(
  api_variables.SERVICE_UPLOAD_TEMPLATE_INSTALLMENT
);
var axios_instance_upload_arrearoverride_template = get_axios_instance(
  api_variables.SERVICE_UPLOAD_TEMPLATE_ARREAROVERRIDE
);
var axios_instance_upload_workbasedays_template = get_axios_instance(
  api_variables.SERVIES_UPLOAD_TEMPLATE_WORKBASEDAYS
);

// const _pk_name = "id";

const state = {
  data: [],
  lopsandrlops: {},
  isFetching: false,
  isSaving: false,
  isDeleting: false
};

const mutations = {
  set: (state, payload) => {
    state.data = payload;
    //console.log("fetched data", state.data);
  },

  setLopsandRlops: (state, payload) => {
    if (payload) {
      state.lopsandrlops = payload;
    }
  },

  addEmployee: (state, payload) => {
    //console.log("payload data from store", payload);
    state.lopsandrlops = payload;
    //console.log("lopsandrlops data", state.lopsandrlops);
    //console.log("state data", state.data);
  },
  setFetching: (state, payload) => {
    state.isFetching = payload;
  },

  setSaving: (state, payload) => {
    state.isSaving = payload;
  },

  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  }
};

const actions = {
  async fetchAll({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_filter_instance.post(``, { data: payload });
      commit("setFetching", false);
      if (res.status == 200) {
        commit("set", res.data.payload.data);
      }
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },
  async fetchLOPsByEmp({ commit }, id) {
    try {
      commit("setFetching", true);
      let res = await axios_instance2.get(`lop/${id}`);
      commit("setFetching", false);
      if (res.status == 200) {
        commit("set", res.data.payload);
      }
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async fetchLopandRlop({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance2.get(
        `/lop/` + "00b87632-c9ad-4e20-9a07-5fef97cbd120"
      );
      commit("setFetching", false);
      if (res.status == 200) {
        commit("setLopsandRlops", res.data.rows);
      }
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async uploadTemplate({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_upload_template.post(``, payload);
      commit("setFetching", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async uploadOnsiteTemplate({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_upload_onsite_template.post(``, payload);
      commit("setFetching", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async uploadTaxoutsidepayrollTemplate({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_upload_taxoutsidepayroll_template.post(``, payload);
      commit("setFetching", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async uploadInstallmentTemplate({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_upload_installment_template.post(``, payload);
      commit("setFetching", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async uploadArrearOverrideTemplate({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_upload_arrearoverride_template.post(``, payload);
      commit("setFetching", false);
      return res;
    } catch (err) {
      throw errorLogSheet(err.response);
    }
  },

  async uploadWorkBaseDayTemplate({ commit }, payload) {
    try {
      commit("setFetching", true);
      let res = await axios_instance_upload_workbasedays_template.post(``, payload);
      commit("setFetching", false);
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async create({ commit }, payload) {
    try {
      commit("setSaving", true);
      let res = await axios_instance1.post("", payload);
      commit("setSaving", false);
      if (res.status == 200) {
        commit("addEmployee", res.data.payload);
      }
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async update({ commit }, payload) {
    try {
      commit("setSaving", true);
      let res = await axios_instance1.put(`/${payload.id}`, payload);
      commit("setSaving", false);
      if (res.status == 200) {
        commit("updateEmployeeById", res.data);
      }
      return res;
    } catch (err) {
      throw errorHandler(err.response);
    }
  },

  async delete({ commit }, payload) {
    try {
      commit("setDeleting", true);
      let res = await axios_instance1.delete(`/${payload.id}`);
      commit("setDeleting", false);
      if (res.status == 200) {
        commit("removeEmployeeById", payload.id);
      }
    } catch (err) {
      throw errorHandler(err.response);
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
